//import { Container, Row, Col } from "react-bootstrap";
import FrontPost from "../../components/FrontPost/FrontPost";
import Post from "../../components/Post/Post";
import postsData from "../../jsondata/posty.json";
import { useState } from "react";
import "./styles.scoped.css";
import { Helmet } from "react-helmet-async";
//import CookiesForm from '../../components/CookiesForm/CookiesForm';
import { PostType } from '../../types/PostType';

interface ContentProps { }

const Aktualnosci: React.FC<ContentProps> = ({ }) => {
  const [IDSend, setIDSend] = useState<number>(-1);
  const [Show, setShow] = useState<boolean>(false);

  return (
    <main className="content">
    <Helmet>
      <title>Wydarzenia - TeamBit</title>
    </Helmet>
    {/* <CookiesForm /> */}
      <h1>Wydarzenia</h1>
      <h4>najważniejsze chwile i wspomnienia naszego koła</h4>
      <div className="posts-layout d-flex">
        <div className={`col-lg-12 col-sm-0 posts-list ${Show ? "stacked" : ""}`}>
          {postsData.length > 1 ? (
            [...postsData].sort((a, b) => Number(b.ID) - Number(a.ID)).slice(1).map((dane: PostType) => (
              <div
                key={dane.ID}
                className="post"
                role="button"
                onClick={() => {
                  setIDSend(dane.ID - 1);
                  setShow(true);
                }}
              >
                <Post
                  title={dane.title}
                  description={dane.description}
                  autor={dane.autor}
                  image={dane.fileID}
                />
              </div>
            ))
          ) : (
            <h2>Brak postów do wyświetlenia</h2>
          )}
        </div>

        {Show && (
          <div className="post-detail col-lg-6 col-sm-12 ">
            <button className="x" onClick={() => setShow(false)}>
              X
            </button>
            <FrontPost postNumber={IDSend} />
          </div>
        )}
      </div>
  </main>

  );
};
export default Aktualnosci;